import type { ClientLocationWithLevel } from "api-types/locations/locationBaseTypes";
import { getLocationPlanName } from "api-types/locations/locationDisplay";
import { snakeCaseToTitleCase } from "common/utils/strings";
import { usePlanLibrarySelector } from "lib/components/builders/plan-library/planLibraryStore";
import { useUserContext } from "lib/state/UserContextProvider";
import LineCapsule from "ui/components/LineCapsule/LineCapsule";

export default function PlanLibrarySubheader({ location }: { location?: ClientLocationWithLevel }) {
  const { builder } = useUserContext();
  const { planType } = usePlanLibrarySelector((state) => {
    return { planType: state.plans.planType };
  });

  const label =
    location && planType === "community_plan"
      ? getLocationPlanName(location, builder?.locationSettings)
      : snakeCaseToTitleCase(planType);

  return <LineCapsule aria-label={`${label} Label`} label={label} />;
}
